<template>
    <b-navbar type="light" class="navbar-light theme-nav fixed-top" toggleable="lg" fixed="top" v-b-scrollspy:nav-scroller>
        <div class="container">
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
            <b-navbar-brand class="navbar-brand" href="/"
            ><img :src="require('../assets/images/smalllogo.png')" alt="logo" /><span class="ml-3"
            ><b class="grey-text text-uppercase">Xtreme<span class="small-screen"> Controls</span></b></span
            ></b-navbar-brand
            >
            <b-collapse class="default-nav" is-nav id="nav_collapse">
                <b-navbar-nav class="navbar-nav ml-auto" id="mymenu">
                    <b-nav-item href="/">Home</b-nav-item>
                    <b-nav-item href="#about" v-if="$route.path == '/'">about</b-nav-item>
                    <b-nav-item href="#feature" v-if="$route.path == '/'">feature</b-nav-item>
                    <b-nav-item href="#screenshot" v-if="$route.path == '/'">screenshot</b-nav-item>
                    <b-nav-item href="#team" v-if="$route.path == '/'">team</b-nav-item>
                    <b-nav-item href="#contact" v-if="$route.path == '/'">contact us</b-nav-item>
                    <b-nav-item-dropdown right-alignment href="#Other_page" text="Examples" class="nav-link ">
                        <b-dropdown-item class="nav-link" :to="{ name: 'hospitalityFeatures' }">Hospitality Demo</b-dropdown-item>
                        <!-- <b-dropdown-item
                        class="nav-link"
                        href="https://demos.xtremecontrols.co.uk/carpark"
                        >Car Park Demo</b-dropdown-item
                        >
                        <b-dropdown-item
                        class="nav-link"
                        href="https://demos.xtremecontrols.co.uk/locker"
                        >Locker Demo</b-dropdown-item
                        >
                        <b-dropdown-item
                        class="nav-link"
                        href="https://demos.xtremecontrols.co.uk/pharmacy"
                        >Pharmacy Locker Demo</b-dropdown-item
                        > -->
                        <b-dropdown-item class="nav-link" :to="{ name: 'care' }">XRMS Leaflet</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </div>
    </b-navbar>
</template>
<script>
export default {
    name: "Navbar"
}
</script>
<style>
.grey-text {
    color: #757575 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue